import { Button, Col, Row, Table } from "react-bootstrap";
import { handleFieldChange, try_catch_fallback } from "../../Utils";

import Container from "../../components/Container";
import Heading from "../../components/Heading";

import React from "react";

import API from "../../services/API";

import SelectWrap from "../../components/SelectWrap";
import FieldGroup from "../../components/FieldGroup";

import _ from 'lodash';

class AdkPartnerDomainReplacementLog extends React.Component {
    constructor() {
        super();

        this.state = {
            loading: true,
            filters: {},
            rows: [],
            types: [],
        }

        this.handleFieldChange = handleFieldChange.bind(this);
        this.load = this.load.bind(this);
    }

    componentDidMount() {
        this.load().catch(console.error);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        console.log(this.state)
    }

    async load() {
        this.setState({ loading: true });

        const filters = {};

        if (this.state.filters.status) filters.status = this.state.filters.status;
        if (this.state.filters.type) filters.type = this.state.filters.type;
        if (this.state.filters.hour) filters['HOUR(created_at)'] = this.state.filters.hour;

        const [ types, rows ] = await Promise.all([
            API.AdkPartnerDomains.get(),
            API.AdkPartnerDomainReplacementLog.get(filters)
        ]);

        this.setState({ loading: false, rows, types: types.map(({ type }) => type) });
    }

    render() {
        return (
            <Container id={'adk-partner-domains'} loading={this.state.loading}>
                <Heading title="ADK Partner Domain Replacement Log" />

                <Row>
                    <Col lg={1}>
                        <FieldGroup
                            type="number"
                            name="filters.hour"
                            label="Hour:"
                            min={0}
                            max={23}
                            onChange={this.handleFieldChange}
                            value={this.state.filters.hour}
                        />
                    </Col>

                    <Col lg={3}>
                        <SelectWrap
                            values={[ 'clean', 'flagged' ]}
                            label="Status:"
                            name="filters.status"
                            onChange={this.handleFieldChange}
                            value={this.state.filters.status}
                            multi
                        />
                    </Col>

                    <Col lg={3}>
                        <SelectWrap
                            values={this.state.types}
                            label="Partner Domain Type:"
                            name="filters.type"
                            onChange={this.handleFieldChange}
                            value={this.state.filters.type}
                            multi
                        />
                    </Col>
                </Row>

                <Row style={{ marginTop: '10px' }}>
                    <Col lg={12}>
                        <Button bsStyle="primary" onClick={this.load}>Load</Button>
                    </Col>
                </Row>

                <Table bordered responsive style={{ width: '100vw', textAlign: 'center', verticalAlign: 'middle', marginTop: '10px' }}>
                    <thead>
                        <tr>
                            <th>Datetime</th>
                            <th>Status</th>
                            <th>ADK Partner Domain Type</th>
                            <th>OLD Domain</th>
                            <th>NEW Domain</th>
                            <th>Notes</th>
                        </tr>
                    </thead>

                    <tbody>
                        {this.state.rows.map((entity, index) => {
                            const raw = try_catch_fallback(JSON.parse, {})(entity.raw);

                            const google_safe_browsing_raw = try_catch_fallback(JSON.parse, {})(_.get(raw, 'google_safe_browsing.raw.data', ""));
                            const google_safe_browsing = _.get(google_safe_browsing_raw, 'matches[0].threatType', "") || _.get(raw, 'google_safe_browsing.data.matches[0].threatType', "");

                            const virus_total_raw = try_catch_fallback(JSON.parse, {})(_.get(raw, 'virustotal.raw.data', ""));
                            const virus_total = _.get(virus_total_raw, 'data.attributes.stats', "");

                            const notes = [
                                { title: 'Notes:', value: entity.notes },
                                { title: 'GSF:', value: google_safe_browsing },
                                { title: 'VT:', value: virus_total },
                            ].filter((x) => x.value).map((x) => `${x.title} ${JSON.stringify(x.value)}`).join(' | ');

                            return (
                                <tr key={index}>
                                    <th style={{ width: '1%', verticalAlign: 'middle', textAlign: 'center'}}>{entity.created_at}</th>
                                    <th style={{ width: '1%', verticalAlign: 'middle', textAlign: 'center'}}>{entity.status}</th>
                                    <th style={{ width: '1%', verticalAlign: 'middle', textAlign: 'center'}}>{entity.type}</th>
                                    <th style={{ width: '1%', verticalAlign: 'middle', textAlign: 'center'}}>{entity.domain}</th>
                                    <th style={{ width: '1%', verticalAlign: 'middle', textAlign: 'center'}}>{entity.replacement}</th>
                                    <th style={{ width: '5%', verticalAlign: 'middle', textAlign: 'center'}}>{notes}</th>
                                </tr>
                            )
                        })}
                    </tbody>
                </Table>
            </Container>
        )
    }
}

export default AdkPartnerDomainReplacementLog;



// WEBPACK FOOTER //
// ./src/scenes/AdkPartnerDomainReplacementLog/index.js